import React, { Component } from 'react'
import { findDOMNode } from 'react-dom';
import { inject, observer } from 'mobx-react'
import InputMask from 'react-input-mask'

import './Settings.scss'

@observer
class EditForm extends Component {
  state = {
    name: '',
    secondname: '',
    thirdname: '',
    phone: '',
    secondPhone: '',
    email: '',
    showUserform: true,
  }

  refsArr = {
    secondname: null,
    thirdname: null,
    secondPhone: null,
    email: null,
    btnSave: null,
  }

  chgInp = evt => {
    this.setState({
        [evt.target.name]: evt.target.value,
    })
  }

  chowHideUserForm = () => {
    this.setState({
      showUserform: !this.state.showUserform
    })
  }

  componentDidMount(){
    const { varFirstName, varLastName, varSurName , varTel, varTel2, varEmail} = this.props.clientInfo
    this.setState({
      name: varFirstName,
      secondname: varLastName,
      thirdname: varSurName,
      phone: varTel,
      secondPhone: varTel2,
      email: varEmail,
    })
  }

  save = () => {
    const {name, secondname, thirdname, phone, secondPhone, email} = this.state
    this.props.saveMyInfo(name, secondname, thirdname, phone, secondPhone, email)
  }

  cancel = () => {
    const { varFirstName, varLastName, varSurName , varTel, varTel2, varEmail} = this.props.clientInfo
    this.setState({
      name: varFirstName,
      secondname: varLastName,
      thirdname: varSurName,
      phone: varTel,
      secondPhone: varTel2,
      email: varEmail,
    })
  }

  handleKeyPress = (event, nextFocus) => {
    if(event.key === 'Enter'){
      if(nextFocus){
          this.refsArr[nextFocus].focus()
      }
    }
  }

  render() {
    return (
      <div className="col">
        <div className="row settings-header" onClick={this.chowHideUserForm}>
          <div className="col">Мои данные</div>
        </div>
        <div className={this.state.showUserform ? "row settings-body" : "row settings-body hide"}>
          <div className="col-12">
            <input type="text" className="form-control webcab-field webcab-field-dark" name="name" value={this.state.name} placeholder="Имя" onChange={this.chgInp} onKeyPress={ evt => this.handleKeyPress(evt, 'secondname')} />
          </div>
          <div className="col-12">
            <input type="text" className="form-control webcab-field webcab-field-dark" name="secondname" value={this.state.secondname} placeholder="Фамилия" onChange={this.chgInp} ref={ target => { this.refsArr.secondname = target }} onKeyPress={ evt => this.handleKeyPress(evt, 'thirdname')} />
          </div>
          <div className="col-12">
            <input type="text" className="form-control webcab-field webcab-field-dark" name="thirdname" value={this.state.thirdname} placeholder="Отчество" onChange={this.chgInp} ref={ target => { this.refsArr.thirdname = target }} onKeyPress={ evt => this.handleKeyPress(evt, 'secondPhone')} />
          </div>
          <div className="col-12">
            <InputMask mask="+380 (99) 999-99-99" disabled={true} className="form-control webcab-field webcab-field-dark" type="text" name="phone" maskChar={null} value={this.state.phone} onChange={this.chgInp} placeholder="Контактный телефон" />
          </div>
          <div className="col-12">
            <InputMask mask="+380 (99) 999-99-99" className="form-control webcab-field webcab-field-dark" type="text" name="secondPhone" maskChar={null} value={this.state.secondPhone} onChange={this.chgInp} placeholder="Дополнительный телефон" ref={ target => { this.refsArr.secondPhone = findDOMNode(target) }} onKeyPress={ evt => this.handleKeyPress(evt, 'email')} />
          </div>
          <div className="col-12">
            <input type="text" className="form-control webcab-field webcab-field-dark" name="email" value={this.state.email} placeholder="E-mail" onChange={this.chgInp} ref={ target => { this.refsArr.email = target }} onKeyPress={ evt => this.handleKeyPress(evt, 'btnSave')} />
          </div>
          <div className="col-6 save">
            <button className="btn btn-save" onClick={this.save} ref={ target => { this.refsArr.btnSave = target }}>Сохранить</button>
          </div>
          <div className="col-6 cancel">
            <button className="btn btn-cancel" onClick={this.cancel}>Отмена</button>
          </div>
        </div>
      </div>
    )
  }
}

const withData = inject(stores => ({
  clientInfo: stores.LoginFromStore.clientInfo,
  saveMyInfo: stores.SettingsStore.saveMyInfo,
}))

export default withData(EditForm);
